import CloseIcon from '@mui/icons-material/Close';
import {Box} from '@mui/material';
import {localized} from 'i18n/i18n';
import {useDialog} from 'providers/dialog-provider';
import {FC, memo, useCallback} from 'react';
import {useSelector} from 'react-redux';
import {selectMachineById} from 'state/features/api/machines-slice';
import {useRemoveMachineFromUserMutation} from 'state/features/api/user-slice';
import {primaryColor} from 'styles/color-constants';
import {theme} from 'styles/theme';
import {FlexRow} from 'view/components/default-components/flex-row';
import MachineIcon from 'view/components/default-components/icons/machine-icon';
import {BasicSpinner} from 'view/components/default-components/spinner/basic-spinner';
import {TextLabel} from 'view/components/default-components/text-label';

interface Props {
  machineId: number;
  userId: number;
}

export const RemoveMachineRow: FC<Props> = memo(({machineId, userId}) => {
  const {openDeleteDialog} = useDialog();
  const machine = useSelector(selectMachineById(machineId));
  const [removeMachineFromUser, {isLoading}] = useRemoveMachineFromUserMutation();

  const onRemove = useCallback(() => {
    if (isLoading) return;
    openDeleteDialog(localized('ConfirmRemoveMachine'), () => {
      removeMachineFromUser({machineId, userId});
    });
  }, [isLoading, machineId, openDeleteDialog, removeMachineFromUser, userId]);

  return (
    <FlexRow
      sx={{
        background: theme.colors.listTable.ListTableBgColor,
        marginTop: 1,
        marginBottom: 1,
        padding: 1,
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
      <FlexRow sx={{alignItems: 'center'}}>
        <MachineIcon />
        <TextLabel variant="h6" color={primaryColor} marginLeft={2}>
          {machine?.serialNumber}
        </TextLabel>
      </FlexRow>
      <Box sx={{cursor: 'pointer', justifyContent: 'center', display: 'flex'}} onClick={onRemove}>
        {isLoading ? <BasicSpinner size={18} /> : <CloseIcon />}
      </Box>
    </FlexRow>
  );
});
